import * as React from 'react';
import * as FontAwesome from 'react-fontawesome';
import { connect, Dispatch } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import TileWall from '../../components/tileWall/tileWall';
// import * as shortId from 'shortid';
import * as Client from '../../data/apiClient/client';
import { ApplicationState } from '../../data/applicationStates';
import { headerActionCreators } from '../../data/header/headerActions';
import { HeaderState } from '../../data/header/headerModels';
import { newsActionCreators } from '../../data/news/newsActions';
import { ApiNewsState /* ApiNewsObject */ } from '../../data/news/newsModels';
// tslint:disable-next-line:no-var-requires
const moment = require('moment');
// tslint:disable-next-line:no-var-requires
const news = require('../../resources/news.png');

import ActiveDirectoryAuthenticator from '../../adal/ActiveDirectoryAuthenticator';
import AdalConfigProvider from '../../adal/AdalConfigProvider';
const ADA = new ActiveDirectoryAuthenticator(new AdalConfigProvider());

interface NewsState {
    news: ApiNewsState;
    header: HeaderState;
}

interface NewsActions {
    newsActions: typeof newsActionCreators;
    headerActions: typeof headerActionCreators;
}

type NewsProps = NewsState & // ... state we've requested from the Redux store
    NewsActions & // ... plus action creators we've requested
    RouteComponentProps<{}>; // ... plus incoming routing parameters

class InternalNews extends React.Component<NewsProps, {}> {
    constructor(props: NewsProps) {
        super(props);
        this.renderNews = this.renderNews.bind(this);
    }

    componentWillMount() {
        this.props.headerActions.setBottomHeader('My Quick Solutions Online');
    }

    componentDidUpdate(prevProps: NewsProps) {
        if (prevProps.news.internalnews !== this.props.news.internalnews) {
            this.forceUpdate();
        }
    }

    openAttachment(id: string) {
        alert(ADA.accessToken);
        const newsClient = new Client.NewsClient();
        const url = newsClient.getBaseUrl('localhost') + '/api/news/document/' + id + '?token=' + ADA.accessToken;
        window.open(url);
    }

    renderNews(props: NewsProps) {
        const arr = Array<any>();
        for (const x of props.news.internalnews) {
            const tileHead = (
                <div>
                    <div className="float-left">
                        <h5>{x.topic}</h5>
                    </div>
                </div>
            );
            const tileBody = (
                <div>
                    <div className="topBorder" />
                    <div>
                        <div className="float-left">{moment(x.publishDate, 'M/D/YYYY').format('M/D/YYYY')}</div>
                        {x.attachmentExists ? (
                            <div className="float-right">
                                <FontAwesome
                                    name="paperclip"
                                    className="link"
                                    size="2x"
                                    onClick={() => this.openAttachment(x.attachmentId)}
                                />
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                    <br />
                    <div>{x.description}</div>
                </div>
            );
            arr.push({
                tileHead: tileHead,
                tileBody: tileBody
            });
        }
        return arr;
    }

    public render() {
        return (
            <div className="container-fluid">
                <div className="componentHeader">
                    <div className="item tile">
                        <div className="tileHead">
                            <div className="float-left">
                                <h4>{'Nordfab Dealer News'}</h4>
                            </div>
                            <div className="tileImage float-right">{<img src={news} />}</div>
                        </div>
                        <div className="tileBody">
                            <div className="topBorder" />
                        </div>
                    </div>
                </div>
                {this.props.news.internalnews.length > 0 ? (
                    <TileWall tileObjects={this.renderNews(this.props)} />
                ) : (
                    <div className="centerThis">
                        <FontAwesome className="progressicon" name="spinner" size="3x" spin={true} />
                    </div>
                )}
            </div>
        );
    }
}

export function mapStateToProps(state: ApplicationState): NewsState {
    return {
        news: state.news,
        header: state.header
    };
}

function mapDispatchToProps(dispatch: Dispatch<{}>): NewsActions {
    return {
        newsActions: bindActionCreators(newsActionCreators, dispatch),
        headerActions: bindActionCreators(headerActionCreators, dispatch)
    };
}

export default withRouter(
    connect(
        mapStateToProps, // Selects which state properties are merged into the component's props
        mapDispatchToProps // Selects which action creators are merged into the component's props
    )(InternalNews)
);



// WEBPACK FOOTER //
// ./src/containers/internalnews/internalnews.tsx